import { publishEvent, MuteToggleResult } from '@salesforce/scv-connector-base';
import { Logger } from '@main/utils/logger';
import type { MuteAgentEventPublisher } from './mute-agent.usecase';

export class MuteAgentPublisher implements MuteAgentEventPublisher {
  private logger: Logger;
  constructor() {
    this.logger = new Logger();
  }

  async publish(onMute: boolean): Promise<void> {
    publishEvent({
      eventType: 'MUTE_TOGGLE',
      payload: new MuteToggleResult({ isMuted: onMute }),
      registerLog: false,
    });
  }
}
